<template>
  <el-dialog
    class="terminal-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
    top="25vh"
  >
    <terminal-board :id="id" ref="terminalDialog"></terminal-board>
  </el-dialog>
</template>

<script>
import terminalBoard from './terminal/WebSSH'
export default {
  name: 'TerminalDialog',
  components: {
    terminalBoard
  },
  data() {
    return {
      title: '终端',
      dialogVisible: false,
      id: ''
    }
  },
  methods: {
    handleCancel() {
      this.$refs.terminalDialog.handleClose()
      this.dialogVisible = false
    },
    handleOpen(id) {
      this.id = id + ''
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.terminalDialog.handleConnect()
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('terminal-dialog', (), ());
.terminal-dialog {
  @include adaptation((
    --terminal-body-padding-bottom: 20px
  ));
  /deep/ .el-dialog {
    width: var(--common-dialog-large-width);
    .el-dialog__body {
      background: var(--base-color-black);
      padding-bottom: var(--terminal-body-padding-bottom);
    }
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);
  }
}
</style>
